import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { AlertTriangle } from 'lucide-react';

export default function AgeVerification() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const verified = sessionStorage.getItem('age_verified');
    if (!verified) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem('age_verified', 'true');
    setShow(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="age-verification-modal">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-8 text-center" data-testid="age-verification-content">
        <div className="w-14 h-14 rounded-full bg-[hsl(210,25%,92%)] flex items-center justify-center mx-auto mb-5">
          <AlertTriangle className="h-7 w-7 text-[hsl(210,52%,21%)]" />
        </div>
        <h2 className="text-xl font-heading font-semibold text-foreground mb-3">Age Verification Required</h2>
        <p className="text-sm text-muted-foreground font-body leading-relaxed mb-2">
          You must be <strong className="text-foreground">21 years of age or older</strong> to access this website.
        </p>
        <div className="bg-[hsl(210,52%,21%)] text-white rounded-lg p-4 my-5">
          <p className="text-xs font-semibold uppercase tracking-wider mb-1">Important Disclaimer</p>
          <p className="text-xs leading-relaxed">
            All peptides on this site are NOT for human or veterinary applications or consumption. Products are sold strictly for in-vitro research and laboratory use only.
          </p>
        </div>
        <p className="text-xs text-muted-foreground font-body mb-6">
          By clicking "I Agree &amp; Enter", you confirm you are 21+ and understand all products are for research use only.
        </p>
        <div className="flex gap-3">
          <Button
            variant="outline"
            className="flex-1"
            onClick={handleDecline}
            data-testid="age-verify-decline"
          >
            I am Under 21
          </Button>
          <Button
            className="flex-1 bg-[hsl(210,45%,40%)] hover:bg-[hsl(210,45%,30%)] text-white"
            onClick={handleAccept}
            data-testid="age-verify-accept"
          >
            I Agree &amp; Enter
          </Button>
        </div>
      </div>
    </div>
  );
}
